import '/assets/styles/pages/amateur-band-form.scss';
import { useState } from 'react';

import config from '@wearetla/tla-essentials-tools/config';

// Partials
import { Form, Input, FormFeedback } from '/views/partials/forms';
import Btn from '/views/partials/btn';
import InfoBox from '/views/partials/info-box';
import { useTranslation } from '/utilities/i18n';
import Turnstile from '/views/partials/turnstile';

// Services
import siteServices from '/services/site';

const AmateurBandForm = () => {
	const { t } = useTranslation();
	const [feedbackData, setFeedbackData] = useState(null);
	const [success, setSuccess] = useState(false);
	const [submitting, setSubmitting] = useState(false);

	const submit = (formFields) => {
		setSubmitting(true);

		siteServices
			.submitAmateurBandForm({
				branch_id: 1,
				...formFields,
			})
			.then((feedback) => {
				setFeedbackData(feedback);
				setSuccess(true);
			})
			.catch((feedback) => {
				setFeedbackData(feedback);
			})
			.finally(() => {
				setSubmitting(false);
			});
	};

	return (
		<>
			<header className="form-header">
				<div className="wrapper">
					<h1 className="header-title">{t('Sahne Senin Başvuru Formu')}</h1>
				</div>
			</header>

			<div className="form-wrap wrapper">
				<div className="form-container">
					{success ? (
						<FormFeedback className="form-successmessage" data={feedbackData} />
					) : (
						<Form onSubmit={submit}>
							<div className="grid-container">
								<FormFeedback inGrid data={feedbackData} />
								<div className="row">
									<div className="col">
										<Input
											disabled={submitting}
											name="name"
											label={t('Sahne İsmi')}
											validation={{
												required: t('Bir grup adı girmelisiniz.'),
											}}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col x6">
										<Input
											disabled={submitting}
											name="genre"
											label={t('Müzik Türü')}
											validation={{
												required: t('Bir müzik türü girmelisiniz.'),
											}}
										/>
									</div>
									<div className="col x6">
										<Input
											disabled={submitting}
											name="socialmedia"
											label={t('Sosyal Medya Hesabı')}
											validation={{
												required: t('Grubun sosyal medya hesabını girmelisiniz.'),
											}}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col">
										<Input
											disabled={submitting}
											type="textarea"
											name="experience"
											label={t('Deneyimleriniz')}
											validation={{
												required: t('Grup deneyiminiz ile ilgili bir şeyler yazmalısınız.'),
											}}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col no-gap-top">
										<InfoBox plain>
											{t('Daha önce hangi etkinliklerde veya projelerde yer aldığınızı anlatın.')}
										</InfoBox>
									</div>
								</div>
								<div className="row">
									<div className="col">
										<Input
											disabled={submitting}
											type="textarea"
											name="purpose"
											label={t('Amacınız')}
											validation={{
												required: t('Grubun ana hedefleri ve amacı nedir?'),
											}}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col no-gap-top">
										<InfoBox plain>{t('Ana hedefleriniz ve amacınız nedir?')}</InfoBox>
									</div>
								</div>
								<div className="row">
									<div className="col">
										<Input
											disabled={submitting}
											type="text"
											name="stage_energy"
											label={t('Sahnedeki enerjinizi üç kelimeyle tanımlar mısınız?')}
											validation={{
												required: t('Sahnedeki enerjinizi tamamlamalısınız'),
											}}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col">
										<Input
											disabled={submitting}
											type="textarea"
											name="stage_story"
											label={t('Sahneye çıktığınızda ne anlatmak istiyorsunuz?')}
											validation={{
												required: t('Sahne anlatınızı kısaca yazmalısınız.'),
											}}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col">
										<Input
											disabled={submitting}
											type="text"
											name="stage_requirements"
											label={t('Sahne ihtiyacınız var mı? (Backline, enstrüman, mikser vs.)')}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col">
										<Input
											disabled={submitting}
											type="number"
											name="stage_group_size"
											label={t('Kaç kişilik bir ekiple sahne alacaksınız?')}
											validation={{
												required: t('Ekip büyüklüğünüzü belirtmelisiniz.'),
											}}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col">
										<Input
											disabled={submitting}
											type="text"
											name="previous_live_experience"
											label={t('Sizi daha önce nerelerde canlı dinledik? (Varsa link ya da mekan adı)')}
										/>
									</div>
								</div>
								{/* <div className="row">
                                    <div className="col">
                                        <Input
                                            disabled={submitting}
                                            type="text"
                                            name="application_reason"
                                            label="Bu projeye neden başvuruyorsunuz?"
                                            validation={{
                                                required: 'Projeye başvurma nedeninizi belirtmelisiniz.'
                                            }} />
                                    </div>
                                </div> */}
								<div className="row">
									<div className="col">
										<Input
											disabled={submitting}
											type="text"
											name="record_studio_label"
											label={t('Kayıt aldığınız stüdyonun ismi nedir?')}
											validation={{
												required: t('Kayıt stüdyonuzun ismini girmelisiniz.'),
											}}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col x6">
										<Input disabled={submitting} name="spotify_link" label={t('Spotify Linki')} />
									</div>
									<div className="col x6">
										<Input disabled={submitting} name="youtube_link" label={t('YouTube Linki')} />
									</div>
								</div>
								<div className="row">
									<div className="col x6">
										<Input
											disabled={submitting}
											type="phone"
											name="phone"
											label={t('Telefon Numarası')}
											validation={{
												required: t('Telefon numaranızı girmelisiniz.'),
												phone: t('Geçerli bir telefon numarası girmelisiniz.'),
											}}
										/>
									</div>
									<div className="col x6">
										<Input
											disabled={submitting}
											name="email"
											label={t('E-Posta Adresi')}
											validation={{
												required: t('E-posta adresinizi girmelisiniz.'),
												email: t('Geçerli bir e-posta adresi girmelisiniz.'),
											}}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col">
										<Input disabled={submitting} type="textarea" name="notes" label={t('Ek Notlar')} />
									</div>
								</div>
								<div className="row">
									<div className="col no-gap-top">
										<InfoBox plain>
											{t('Sizin hakkınızda eklemek istediğiniz herhangi bir önemli bilgi veya not.')}
										</InfoBox>
									</div>
								</div>
								{!!config.turnstile?.siteKey &&
									<div className="row">
										<div className="col">
											<Turnstile id="turnstile-amateur-band-form" />
										</div>
									</div>
								}
								<div className="row">
									<div className="col">
										<Btn
											disabled={submitting}
											loading={submitting}
											className="primary big block text-big"
											type="submit"
										>
											{t('Gönder')}
										</Btn>
									</div>
								</div>
							</div>
						</Form>
					)}
				</div>
			</div>
		</>
	);
};

export default AmateurBandForm;
